import styles from "./PrivacyPolicyPage.module.css";
import Header from "../../components/Header";
import { PRIVACY } from "../../components/settings/PolicyContent";

export default function PrivacyPolicyPage() {
  return (
    <div className={styles.wrapper}>
      <Header />

      <div className={styles.hero}>
        <div className={styles.heroContent}>
          <span className={styles.badge}>Legal</span>

          <h1 className={styles.title}>
            Privacy Policy
          </h1>

          <p className={styles.subtitle}>
            Learn how NESSEFY collects, uses and protects your information.
          </p>
        </div>
      </div>

      <div className={styles.container}>
        <div className={styles.card}>

          <div className={styles.content}>
            {PRIVACY.split("\n").map((line, index) => {

              if (!line.trim()) {
                return <div key={index} className={styles.space} />;
              }

              const emailMatch =
                line.match(/\[(.*?)\]\(mailto:(.*?)\)/);

              if (emailMatch) {
                return (
                  <div
                    key={index}
                    className={styles.contactCard}
                  >
                    <span>📩 Contact Support</span>

                    <a
                      href={`mailto:${emailMatch[2]}`}
                      className={styles.link}
                    >
                      {emailMatch[1]}
                    </a>
                  </div>
                );
              }

              const isHeading =
                line === line.toUpperCase() &&
                line.length < 50;

              return (
                <div key={index}>
                  {isHeading ? (
                    <h2 className={styles.heading}>
                      {line}
                    </h2>
                  ) : (
                    <p className={styles.text}>
                      {line}
                    </p>
                  )}
                </div>
              );
            })}
          </div>

        </div>
      </div>
    </div>
  );
}